export { default } from "./pages/SireComprasPage";
